(ns storrito.connect3.connect-via-private-proxy
  (:require [storrito.ui.button :as button]))

(defn panel
  [state]
  [:div.flex.items-center.gap-5.flex-col.mt-4.mb-0
   [:div.flex
    [:div.w-full.text-left
     [:label.text-gray-800.block.text-base.font-bold.mb-2 "Paste your Proxy URL here:"]
     [:input.bg-white.border-gray-400.rounded.text-gray-800.shadow-sm.focus:hover:border-gray-500.focus:shadow-md.w-full
      {:style {:max-width "400px"}
       :placeholder "Proxy URL"
       :name "private-proxy-url"
       :type "text"
       :required true
       :on {:change [[:store/assoc-in [:connect3 :proxy] :event/target.value]]}
       :value ""}]
     (when-let [error-message (:error-message state)]
       [:div.font-bold.text-red-500.mt-4.whitespace-pre-line error-message])]]

   [:div.flex.justify-end.w-full
    (button/button-primary
      {:class "self-end"
       :disabled (:sending? state)
       :on {:click [[:connect3/send! (select-keys state
                                                  [:proxy])]]}}
      (if (:sending? state)
        "Checking proxy..."
        "Proceed"))]])
